// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__yiwzD","btnContainer":"FAQ_btnContainer__1V+Ji","btn":"FAQ_btn__a6b11"};